import store from '@/store'

let constantTabList = {
  tabListSale() {
    let result = [
      {
        key: '核算单明细表',
        val: '/sale/verify/info-list'
      },
      {
        key: '核算单列表',
        val: '/sale/verify/list'
      },
      {
        key: '订单明细表',
        val: '/sale/order/info-list'
      },
      {
        key: '订单列表',
        val: '/sale/order/list'
      },
      {
        key: '送货单列表',
        val: '/sale/delivery/list'
      }
    ]
    return result
  },
  tabListCustomer() {
    let isAdmin = store.getters.getRoleObj.isAdmin
    let result = [
      {
        key: '客户列表',
        val: '/sale/customer/user/list'
      },
      {
        key: '客户成本',
        val: '/sale/customer/cost/list'
      }
    ]
    if (isAdmin) {
      result.push({
        key: '客户分析',
        val: '/sale/customer/analyze/list'
      })
    }
    return result
  },
  tabListAccount() {
    let result = [
      {
        key: '员工管理',
        val: '/system/account/list'
      },
      {
        key: '岗位列表',
        val: '/system/role/list'
      },
      {
        key: '游客列表',
        val: '/system/account/tourist'
      }
    ]
    return result
  },
  tabListStock() {
    let result = [
      {
        key: '商品表头属性管理',
        val: '/stock/stock/head'
      },
      {
        key: '库存商品单价管理',
        val: '/stock/stock/price'
      },
      {
        key: '库存列表',
        val: '/stock/stock/list'
      }
    ]
    return result
  },
  tabListStockIn() {
    let result = [
      {
        key: '入库申请列表',
        val: '/stock/stock-in/wait/list'
      },
      {
        key: '已入库列表',
        val: '/stock/stock-in/finish/list'
      }
    ]
    return result
  },
  tabListStockOut() {
    let result = [
      {
        key: '出库申请列表',
        val: '/stock/stock-out/wait/list'
      },
      {
        key: '已出库列表',
        val: '/stock/stock-out/finish/list'
      }
    ]
    return result
  },
  tabListGoodsSystem() {
    let result = [
      {
        key: '商品列表',
        val: '/goods/system/shang-pin'
      },
      {
        key: '模板列表',
        val: '/goods/system/mu-ban'
      },
      {
        key: '类目管理',
        val: '/goods/category/manage'
      },
      {
        key: '字段管理',
        val: '/goods/system/zi-duan'
      }
    ]
    return result
  },
  tabListSupplier() {
    let result = [
      {
        key: '供应商列表',
        val: '/purchase/supplier/user/list'
      }
    ]
    return result
  },
  tabListPurchase() {
    let result = [
      {
        key: '采购申请单',
        val: '/purchase/apply/list'
      },
      {
        key: '采购订单',
        val: '/purchase/order/list'
      }
    ]
    return result
  },
  tabListProduction() {
    let result = [
      {
        key: '订单列表',
        val: '/production/order/list'
      },
      {
        key: '工单列表',
        val: '/production/process/list'
      },
      {
        key: '任务列表',
        val: '/production/task/list'
      }
    ]
    return result
  },
  tabListLocation() {
    let result = [
      {
        key: '工区管理',
        val: '0'
      },
      {
        key: '场地管理',
        val: '1'
      }
    ]
    return result
  },
  tabListRole() {
    let result = [
      {
        key: '职位列表',
        val: '/company/gangwei/role/list'
      },
      {
        key: '职位分类',
        val: '/company/gangwei/role/category'
      },
      {
        key: '职务列表',
        val: '/company/gangwei/job/list'
      },
      {
        key: '职级列表',
        val: '/company/gangwei/level/list'
      },
      {
        key: '文档列表',
        val: '/company/gangwei/doc/list'
      },
      {
        key: '文档分类',
        val: '/company/gangwei/doc/category'
      }
    ]
    return result
  },
  tabListDangan() {
    let result = [
      {
        key: '教育经历',
        val: '/company/dangan/jiaoyu/list'
      },
      {
        key: '工作经历',
        val: '/company/dangan/gongzuo/list'
      },
      {
        key: '家庭成员',
        val: '/company/dangan/jiating/list'
      },
      {
        key: '员工证书',
        val: '/company/dangan/zhengshu/list'
      },
      {
        key: '技能特长',
        val: '/company/dangan/jineng/list'
      }
    ]
    return result
  },
  tabListZhiZao() {
    let result = [
      {
        key: '制造明细',
        val: '0'
      },
      {
        key: '成本明细',
        val: '1'
      }
    ]
    return result
  }
}

export default constantTabList
